"use strict"; //Alex
import { ref, createApp } from "vue";
import App from "./App.vue";
import { LoadingPlugin } from "./index"; //Alex
import router from "./router";
import store from "./store";
import PrimeVue from "primevue/config";

// For accessibility reasons. Same as saga-green, but light
// greens are modified to be #00632C - yigit.sen
// import "primevue/resources/themes/saga-green/theme.css";
import "./style/theme.css";
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.min.css";
import "primeicons/primeicons.css";
import "./main.css";
import "primeflex/primeflex.css";

import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import Sidebar from "primevue/sidebar";
import Card from "primevue/card";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Password from "primevue/password";
import SelectButton from "primevue/selectbutton";
import ScrollPanel from "primevue/scrollpanel";
import Calendar from "primevue/calendar";
import Listbox from "primevue/listbox";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import FileUpload from "primevue/fileupload";
import AutoComplete from "primevue/autocomplete";
import InputMask from "primevue/inputmask";
import Tooltip from "primevue/tooltip";
import MultiSelect from "primevue/multiselect";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Divider from "primevue/divider";
import PanelMenu from "primevue/panelmenu";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmPopup from "primevue/confirmpopup";
import ConfirmDialog from "primevue/confirmdialog";
import ProgressBar from "primevue/progressbar";
import Image from "primevue/image";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";
import CascadeSelect from "primevue/cascadeselect";
import VirtualScroller from "./components/virtualscroller";

import axios from "axios";
import VueAxios from "vue-axios";

let isHandlingAuthRedirect = false;

function logoutLocally() {
  if (isHandlingAuthRedirect) {
    return;
  }

  isHandlingAuthRedirect = true;
  store.dispatch("logout");
  localStorage.removeItem("epd-cnmp-user");

  if (router.currentRoute?.value?.path !== "/Login") {
    router.replace("/Login").catch(() => { });
  }

  setTimeout(() => {
    isHandlingAuthRedirect = false;
  }, 0);
}

axios.interceptors.response.use(
  (response) => {
    if (response.headers["Content-Type"] === "text/html") {
      logoutLocally();
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      logoutLocally();
    }
    return Promise.reject(error);
  }
);

const app = createApp({
  extends: App,
  mounted() {
    window.onbeforeunload = this.handleBeforeUnload;
    // prevent right click
    document.addEventListener(
      "contextmenu",
      (e) => {
        e.preventDefault();
      },
      false
    );
    // document.addEventListener("keydown", (e) => {
    //   if (e.ctrlKey && e.keyCode == 123) {
    //     e.stopPropagation();
    //     e.preventDefault();
    //   }
    // });
  },
  methods: {
    handleBeforeUnload(event) {
      if (this.$store.getters.currentProject?.id) {
        event.preventDefault();
        event.returnValue = "";
        this.axios.post(`${this.apiEndpoint}project/close?id=${this.$store.getters.currentProject.id}`);
      }
    },
  },
});

app.use(store);
app.use(router);

app.use(PrimeVue);
app.use(ConfirmationService);
app.component("Toolbar", Toolbar);
app.component("Button", Button);
app.component("Sidebar", Sidebar);
app.component("Card", Card);
app.component("InputText", InputText);
app.component("InputNumber", InputNumber);
app.component("Password", Password);
app.component("SelectButton ", SelectButton);
app.component("ScrollPanel", ScrollPanel);
app.component("Calendar", Calendar);
app.component("Listbox", Listbox);
app.component("Dropdown", Dropdown);
app.component("RadioButton", RadioButton);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("FileUpload", FileUpload);
app.component("AutoComplete", AutoComplete);
app.component("InputMask", InputMask);
app.component("MultiSelect", MultiSelect);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Divider", Divider);
app.component("PanelMenu", PanelMenu);
app.component("ConfirmPopup", ConfirmPopup);
app.component("ConfirmDialog", ConfirmDialog);
app.component("ProgressBar", ProgressBar);
app.component("Image", Image);
app.component("Dialog", Dialog);
app.component("Checkbox", Checkbox);
app.component("CascadeSelect", CascadeSelect);
app.component("VirtualScroller", VirtualScroller);

app.directive("tooltip", Tooltip);

app.use(VueAxios, axios);
app.use(LoadingPlugin); //Alex

//app.config.globalProperties.apiEndpoint = 'api/' //publish
//app.config.globalProperties.fileEndpoint = 'files/' //publish
// app.config.globalProperties.apiEndpoint =
//   "http://ec2-16-163-54-111.ap-east-1.compute.amazonaws.com/api/"; //server prod
// app.config.globalProperties.apiEndpoint = "https://web-cnmp.net/api/"; //server https
app.config.globalProperties.apiEndpoint = "/api/"; //gcis server side proxy
// app.config.globalProperties.apiEndpoint = "http://192.168.8.6/api/"; //gcis server test env
// app.config.globalProperties.apiEndpoint = "http://192.168.10.7/api/"; //gcis server prod env
// app.config.globalProperties.apiEndpoint = "http://ec2-18-167-243-150.ap-east-1.compute.amazonaws.com/api/"; //server dev
// app.config.globalProperties.apiEndpoint = "https://localhost:44384/"; //dev
// app.config.globalProperties.fileEndpoint =
//   "http://ec2-16-163-54-111.ap-east-1.compute.amazonaws.com/files/"; //server prod
// app.config.globalProperties.fileEndpoint = "https://web-cnmp.net/files/"; //server prod
// app.config.globalProperties.fileEndpoint = "http://ec2-18-167-243-150.ap-east-1.compute.amazonaws.com/files/"; //server dev
app.config.globalProperties.fileEndpoint = "/api/file/download?path="; //gcis server side proxy
// app.config.globalProperties.fileEndpoint = "http://192.168.10.7/api/file/download?path="; //gcis server prod env
// app.config.globalProperties.fileEndpoint = "http://192.168.8.6/api/file/download?path="; //gcis server test env

app.config.globalProperties.version = "v2026.06.04";

app.mount("#app");
